import {defaultPagination} from "@/services/pagination";
import {listUsers} from "@/services/api/app/entraId/users";
import {refresh, exportSnapshot} from "@/services/api/app/office/entraId/seats";

const defaultState = () => ({
  users: [],
  pagination: {
    ...defaultPagination(),
    sortBy: 'displayName',
    sortDescending: true,
  },
  search: '',
});

export default {
  namespaced: true,

  actions: {
    list({commit, state}) {
      return listUsers({
        pagination: state.pagination,
        searchTerm: state.search || ''
      })
        .then(({result, pagination}) => {
          commit('setUsers', result);
          commit('setPagination', pagination);
        })
        .catch(error => {
          console.error("Failed to list users:", error);
          throw error;
        });
    },
    refresh() {
      return refresh();
    },
    exportSnapshot({state}) {
      return exportSnapshot(null, null, null, state.search, state.pagination);
    },
  },

  mutations: {
    setUsers(state, users) {
      state.users = users;
    },
    setPagination(state, pagination) {
      state.pagination = pagination;
    },
    resetPagination(state) {
      state.pagination = {
        ...defaultPagination(),
        sortBy: 'displayName',
        sortDescending: true,
      };
    },
    setSearch(state, search) {
      state.search = search || '';
    },
    resetState(state) {
      Object.assign(state, defaultState())
    },
  },

  state: defaultState(),
}
